/* icon/UI 24px/Medical Small (cross).svg: width 24px x height 24px */
export default class DlsIconMedicalSmall extends HTMLElement {
  static define(tagName = 'dls-icon-medical-small') {
    try {
      window.customElements.define(tagName, this);
    } catch (e) {
      /* console.error(e); */
    }
  }
  connectedCallback() {
    this.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" display="block" pointer-events="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 8.583v6.834h6.833v6.833h6.834v-6.833h6.833V8.583h-6.833V1.75H8.583v6.833H1.75z" clip-rule="evenodd"/></svg>`;
  }
}
DlsIconMedicalSmall.define();
